import {create} from 'zustand';

interface ToastState {
    isVisible: boolean;
    message: string;
    duration: number;
    autoClose: boolean;
    showToast: ({message, duration, autoClose}: {message: string; duration?: number; autoClose?: boolean}) => void;
    hideToast: () => void;
}

export const useToastStore = create<ToastState>(set => ({
    isVisible: false,
    message: '',
    duration: 3000,
    autoClose: true,
    showToast: ({
        message,
        duration = 3000,
        autoClose = true,
    }: {
        message: string;
        duration?: number;
        autoClose?: boolean;
    }) =>
        set({
            isVisible: true,
            message,
            duration,
            autoClose,
        }),
    hideToast: () =>
        set({
            isVisible: false,
            message: '',
        }),
}));
